/**
 * Configuration types.
 */
export enum ConfigurationTypes {
    SPINE_ANIMATIONS = "spine_animation",
    SYMBOL_SPINE_ANIMATIONS = "symbol_spine_animation",
    WIN_SYMBOL_SPINE_ANIMATIONS = "win_symbol_spine_animation",
    BUY_FEATURE = "buy_feature",
    BET = "bet",
    SETTINGS = "settings",
    LOCAL = "local",
    GAME = "game",
    GAME_SPECIFIC = "game_specific",
    ERROR = "error",
    VENDOR_SERVER = "vendor_server",
    JACKPOT_BANNER = "jackpot_banner",
    SCENE_VIEW = "scene_view",
    COMPONENTS = "components",
    REEL = "reel"
}
